module.exports = __webpack_public_path__ + "static/media/codepen.dccc72d8.png";